import React from 'react';
import { Box, Tooltip, Typography } from '@mui/material';

const getDatesInRange = (from, to) => {
    const dates = [];
    const current = new Date(from);
    const end = new Date(to);
    while (current < end) {
        dates.push(current.toISOString().split('T')[0]);
        current.setDate(current.getDate() + 1);
    }
    return dates;
};

const getCoveredDates = (room_stays) => {
    if (!room_stays?.length) return [];
    return [...new Set(room_stays.map(rs => rs.date))].sort();
};

const CoverageBadge = ({ hotel, isArabic }) => {
    if (!hotel.check_in_date || !hotel.check_out_date) return null;
    const expectedDates = getDatesInRange(hotel.check_in_date, hotel.check_out_date);
    const coveredDates = getCoveredDates(hotel.room_stays);
    const covered = expectedDates.filter(d => coveredDates.includes(d));
    const missing = expectedDates.filter(d => !coveredDates.includes(d));
    const allCovered = missing.length === 0;

    return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
            {expectedDates.map(date => {
                const isCovered = coveredDates.includes(date);
                return (
                    <Tooltip key={date} title={`${date} ${isCovered ? (isArabic ? '✓' : '✓') : (isArabic ? '✗' : '✗')}`}>
                        <Box
                            sx={{
                                width: 10, height: 16, borderRadius: 0.5,
                                bgcolor: isCovered ? 'success.main' : 'error.main',
                                opacity: isCovered ? 0.8 : 0.5,
                                cursor: 'pointer',
                            }}
                        />
                    </Tooltip>
                );
            })}
            <Typography variant="caption" sx={{ ml: 0.5, fontSize: '0.65rem', color: allCovered ? 'success.main' : 'error.main' }}>
                {allCovered
                    ? `\u2713 ${covered.length}/${expectedDates.length}`
                    : `\u2717 ${covered.length}/${expectedDates.length}`
                }
            </Typography>
        </Box>
    );
};

export default CoverageBadge;
